export default "__VITE_ASSET__e1d50f35__"